import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import dayjs from "dayjs";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../utils/UtilsFormule";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const DataTableTicketCredit = ({ credits }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [credits, setcredits] = useState(availableTicket);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;

  function PriceFormatter(cell, row) {
    if (cell != null && cell != "") {
      return <span>{cell} TND</span>;
    } else {
      return <span>-</span>;
    }
  }

  function DateFormatter(cell, row) {
    if (cell != null && cell != "") {
      return UtilsFormule.formatDateHours(cell);
    } else {
      return <span>-</span>;
    }
  }

  function typePayementFormatter(cell, row) {
    switch (cell) {
      case "accept":
        return "Accepté";
      case "refuse":
        return "Rejeté";
      case "refuse-def":
        return "Refusé définitivement";
      case "none":
        return "non rapproché";
      default:
        return "-";
    }
  }
  function referenceFormatter(cell, row) {
    switch (row?.typePayement) {
      case "Espéce":
        return row.ref + "-" + row.year;
      case "En ligne":
        return row.ref;
      case "Chéque / Traites":
        return row.codeCheque;
      case "Virement":
        return row.numVirement;
      case "CarteCadeau":
        return row.ref + "-" + row.year;
      default:
        return null;
    }
  }
  const columns = [
    {
      dataField: "reference",
      text: "#Référence",
      align: "center",
      headerAlign: "center",
      // formatter: referenceFormatter,
    },
    {
      dataField: "creationDate",
      text: "Date de création",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (cell ? dayjs(cell).format("DD/MM/YYYY HH:mm:ss") : ""),
    },
    {
      dataField: "typePayement",
      text: "Type",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "price",
      text: "Prix",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => `${cell} TND`,
    },
    {
      dataField: "restToPay",
      text: "reste à payer",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => `${cell} TND`,
    },
    {
      dataField: "amountPayed",
      text: "M.Payé",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ credits }) {
    return credits;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Crédits</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={credits}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                {/* <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div> */}
                {/* <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps} />{" "}
                </div> */}
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableTicketCredit;
